export default __webpack_public_path__ + "static/media/Martiyers3.55bcb1ca.jpg";